import { useParams, Link, Navigate } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { BookingWidget } from "@/components/BookingWidget";
import { ROOMS } from "@/data/site";

export default function RoomDetail() {
  const { slug } = useParams();
  const room = ROOMS.find((r) => r.slug === slug);
  if (!room) return <Navigate to="/rooms" replace />;

  return (
    <div data-testid={`room-detail-page-${room.slug}`}>
      <PageHero overline={`${room.occupancy} · ${room.bed}`} title={room.name} subtitle={room.short} image={room.image} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <Link to="/rooms" className="inline-flex items-center gap-2 text-white/50 hover:text-[#d4af37] text-sm mb-12 transition-colors duration-300" data-testid="back-to-rooms-link">
          <ArrowLeft size={15} /> All Accommodation
        </Link>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-7">
            <FadeUp>
              <h2 className="font-serif-display text-3xl md:text-4xl font-light text-white mb-6">The room</h2>
              <p className="text-[#a3a3a3] leading-relaxed">{room.description}</p>
              <p className="mt-8 text-sm text-white/50">Breakfast included · Rates confirmed on enquiry by our reservations team</p>
              <h3 className="font-serif-display text-2xl font-light text-white mt-12 mb-6">Amenities</h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {room.amenities.map((a) => (
                  <li key={a} className="flex items-center gap-3 text-sm text-white/70">
                    <Check size={15} className="text-[#d4af37] shrink-0" /> {a}
                  </li>
                ))}
              </ul>
            </FadeUp>
          </div>
          <div className="lg:col-span-5">
            <FadeUp delay={0.1}><BookingWidget compact defaultRoom={room.name} /></FadeUp>
          </div>
        </div>
      </section>
    </div>
  );
}
